import React from 'react';
import { useAudio } from '@/app/providers/AudioProvider';
import ToggleFFXIV from './ToggleFFXIV';
import TooltipWithIconFFXIV from './TooltipWithIconFFXIV';
import { useTranslation } from '@/hooks/useTranslation';

const AudioSettings = () => {
    const { timerEnabled, othersEnabled, volume, setTimerEnabled, setOthersEnabled, setVolume } = useAudio();
    const { t } = useTranslation();

    return (
        <div className="space-y-1">
            <div className="flex justify-between items-center gap-5">
                <div className="text-[#EEEEEE] text-lg text-shadow shadow-black/70 whitespace-nowrap">{t('settings.audio.title')}</div>
                <TooltipWithIconFFXIV
                    position="left"
                    text={t('settings.audio.tooltip')}
                />
            </div>
            <div className="ml-3 flex flex-col gap-0.5">
                <ToggleFFXIV
                    value={timerEnabled}
                    onChange={() => setTimerEnabled(!timerEnabled)}
                    text={t('settings.audio.timer')}
                    shape='square'
                />
                <ToggleFFXIV
                    value={othersEnabled}
                    onChange={() => setOthersEnabled(!othersEnabled)}
                    text={t('settings.audio.others')}
                    shape='square'
                />
            </div>
            <div className="ml-3 mt-2 flex flex-col gap-1">
                <div className="text-[#CCCCCC] text-sm text-shadow shadow-black/70">
                    {t('settings.audio.volume')}: {Math.round(volume * 100)}%
                </div>
                <input
                    type="range"
                    min="0"
                    max="100"
                    value={volume * 100}
                    onChange={(e) => setVolume(Number(e.target.value) / 100)}
                    className="w-full h-2 bg-[#3a3a3a] rounded-lg appearance-none cursor-pointer 
                             [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:h-4 
                             [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-[#c0a270] 
                             [&::-webkit-slider-thumb]:cursor-pointer [&::-webkit-slider-thumb]:border-2 
                             [&::-webkit-slider-thumb]:border-[#e0c290]
                             [&::-moz-range-thumb]:w-4 [&::-moz-range-thumb]:h-4 
                             [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:bg-[#c0a270] 
                             [&::-moz-range-thumb]:cursor-pointer [&::-moz-range-thumb]:border-2 
                             [&::-moz-range-thumb]:border-[#e0c290] [&::-moz-range-thumb]:border-none"
                />
            </div>
        </div >
    );
};

export default AudioSettings;
